// === CONFIG ===
const GIFT_WRAP_VARIANT_ID = 46717319839896;
const FREE_PRODUCT_VARIANT_ID = 46629979324568;
const FREE_THRESHOLD = 49900; // ₹499 in paisa

// === Toggle Gift Note Area ===
function toggleGiftNoteArea(show) {
  const noteContainer = document.getElementById('giftNoteContainer');
  if (!noteContainer) return;

  if (show) {
    noteContainer.style.display = 'block';
    noteContainer.style.maxHeight = '200px';
  } else {
    noteContainer.style.maxHeight = '0';
    setTimeout(() => {
      noteContainer.style.display = 'none';
    }, 400);
  }
}

// === Shopify Core Overrides ===
Shopify.onItemAdded = function (line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function (cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
  const checkbox = document.getElementById('giftWrapCheckbox');
  if (checkbox) {
    const hasGiftWrap = cart.items.some(i => i.variant_id === GIFT_WRAP_VARIANT_ID);
    checkbox.checked = hasGiftWrap;
    toggleGiftNoteArea(hasGiftWrap);
  }
  handleFreeProduct(cart);
};

Shopify.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  var str = data.message ? data.description : 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(() => {
    jQuery('.minicart-inner').removeClass("show dontshow");
  }, 1000);
  jQuery('.minicart-inner').addClass("dontshow");
};

Shopify.addItem = function (variant_id, quantity, callback) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + (quantity || 1) + '&id=' + variant_id,
    dataType: 'json',
    success: function (line_item) {
      if (typeof callback === 'function') {
        callback(line_item);
      } else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: Shopify.onError
  });
};

Shopify.addItemFromForm = function (form_id, variant_id, callback) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    beforeSend: function () {
      if (form_id === "add-item-qv") {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function (line_item) {
      if (typeof callback === 'function') {
        callback(line_item);
      } else {
        if (form_id !== "add-item-qv") {
          Shopify.cartPopapForm(variant_id);
        } else {
          const btn = jQuery('#' + form_id).find(".addtocartqv");
          btn.html(jQuery(".quickViewModal_info .button_added").html()).addClass("added_in_cart");
          setTimeout(() => {
            btn.removeClass("added_in_cart").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (form_id !== "add-item-qv") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        const btn = jQuery('#' + form_id).find(".addtocartqv");
        btn.html(jQuery(".quickViewModal_info .button_error").html()).addClass("error_in_cart");
        setTimeout(() => {
          btn.removeClass("error_in_cart").html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
    }
  });
};

Shopify.addItemFromFormStart = function (form, product_id) {
  Shopify.addItemFromForm(form, product_id);
};

Shopify.cartPopap = function (variant_id) {
  var image = jQuery('.' + variant_id + ':first .popup_cart_image').attr("data-srcset");
  var title = jQuery('.' + variant_id + ':first .popup_cart_title').text();
  jQuery('.popupimage').attr("src", image);
  jQuery('.productmsg').text(title);
  jQuery('#modalAddToCart').modal("toggle");
};

Shopify.cartPopapForm = function (variant_id) {
  var image = jQuery('.product_variant_image').attr("src");
  var title = jQuery('#popup_cart_title').text();
  jQuery('.popupimage').attr("src", image);
  jQuery('.productmsg').text(title);
  jQuery('#modalAddToCart').modal("toggle");
};

// === Free Shipping Progress Bar ===
function updateFreeShippingProgress(cart) {
  var freeShippingThreshold = 49900;
  var cartTotal = cart.total_price;
  var remaining = freeShippingThreshold - cartTotal;
  var percentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

  jQuery('.progress-bar-inner').css('width', percentage + '%');

  if (remaining > 0) {
    jQuery('.progress-text').html(
      '🎁 Add <span class="amount-left money">' +
      Shopify.formatMoney(remaining, window.money_format) +
      '</span> more for free gift!'
    );
  } else {
    jQuery('.progress-text').html('<strong>🎉 You’ve unlocked free gift!</strong>');
  }

  if (window.show_multiple_currencies && typeof Currency !== 'undefined') {
    Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '.money');
  }
}

// === Cart Update Handler ===
Shopify.cartUpdateInfo = function (cart, cart_cell_id) {
  var formatMoney = window.money_format;
  var cart_cell = jQuery(cart_cell_id);

  if (cart_cell.length) {
    cart_cell.empty();
    jQuery.each(cart.items, function (i, item) {
      if (i > 19) return false;
      jQuery('<div class="minicart-item"><div class="minicart-thumb"><a href="' + item.url + '"><img src="' + item.image + '" alt=""></a></div><div class="minicart-content"><h3 class="product-name"><a href="' + item.url + '">' + item.title + '</a></h3><p><span class="cart-quantity">' + item.quantity + ' <strong>&times;</strong></span><span class="cart-price">' + Shopify.formatMoney(item.price, formatMoney) + '</span></p></div><a class="minicart-remove" href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="pe-7s-trash"></i></a></div>').appendTo(cart_cell);
    });

    jQuery(".minicart-content-box").toggle(cart.items.length > 0);
    jQuery(".cart-empty-title").toggle(cart.items.length === 0);
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);
  updateFreeShippingProgress(cart);
  jQuery('.currency .active').trigger('click');
};

function changeHtmlValue(cell, value) {
  jQuery(cell).html(value);
}

// === Gift Wrap Logic ===
function setGiftWrapQuantity(quantity, callback = () => {}) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const item = cart.items.find(i => i.variant_id === GIFT_WRAP_VARIANT_ID);
      if (item && quantity === 0) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        }).then(() => {
          Shopify.getCart();
          callback();
        });
      } else if (item && quantity !== item.quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity })
        }).then(() => {
          Shopify.getCart();
          callback();
        });
      } else if (!item && quantity > 0) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: GIFT_WRAP_VARIANT_ID, quantity: 1 })
        }).then(() => {
          Shopify.getCart();
          callback();
        });
      } else {
        callback();
      }
    });
}

// === Free Product Logic ===
function handleFreeProduct(cart) {
  const hasFreeItem = cart.items.some(i => i.variant_id === FREE_PRODUCT_VARIANT_ID);

  if (cart.total_price >= FREE_THRESHOLD && !hasFreeItem) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: FREE_PRODUCT_VARIANT_ID, quantity: 1 })
    }).then(() => {
      Shopify.getCart();
    });
  }

  if (cart.total_price < FREE_THRESHOLD && hasFreeItem) {
    const freeItem = cart.items.find(i => i.variant_id === FREE_PRODUCT_VARIANT_ID);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: freeItem.key, quantity: 0 })
    }).then(() => {
      Shopify.getCart();
    });
  }
}

// === DOM Ready Setup ===
jQuery(document).ready(function () {
  Shopify.getCart(function (cart) {
    updateFreeShippingProgress(cart);
    handleFreeProduct(cart);
  });

  const checkbox = document.getElementById('giftWrapCheckbox');
  if (checkbox) {
    checkbox.addEventListener('change', function () {
      const checked = checkbox.checked;
      setGiftWrapQuantity(checked ? 1 : 0, () => {
        toggleGiftNoteArea(checked);
      });
    });

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const item = cart.items.find(i => i.variant_id === GIFT_WRAP_VARIANT_ID);
        checkbox.checked = !!item;
        toggleGiftNoteArea(!!item);
      });
  }

  // Uncheck gift wrap checkbox if gift wrap is removed
  jQuery(document).on('click', `.minicart-remove[onclick*="${GIFT_WRAP_VARIANT_ID}"]`, function () {
    const checkbox = document.getElementById('giftWrapCheckbox');
    if (checkbox) {
      setTimeout(() => {
        checkbox.checked = false;
        toggleGiftNoteArea(false);
      }, 1000);
    }
  });

  // Recheck free product logic after any item is removed
  jQuery(document).on('click', `.minicart-remove`, function () {
    setTimeout(() => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          handleFreeProduct(cart);
        });
    }, 1000);
  });

  // Trigger free product logic when cart icon is clicked
  const cartIcon = document.querySelector('.minicart-btn');
  if (cartIcon) {
    cartIcon.addEventListener('click', function () {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          handleFreeProduct(cart);
        });
    });
  }
});